export default __webpack_public_path__ + "static/media/004-maple syrup.3e941aff.svg";